import { createCRUDHook } from './createCRUDHook';
import { customerContactDto } from 'utils/models';
import {
  GET_ALL_CUSTOMER_CONTACT_BY_CUSTOMER_ID,
  TLKP_CUSTOMER_CONTACT,
} from './apiEndPoints';

interface CustomerContactCustomOperations {
  fetchCustomerContactDataByCustomerId: (
    id: number
  ) => Promise<customerContactDto[]>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  customerContactDto,
  customerContactDto[],
  CustomerContactCustomOperations
>({
  entityName: 'CustomerContact',
  endpoint: TLKP_CUSTOMER_CONTACT,

  customOperations: (auth) => ({
    fetchCustomerContactDataByCustomerId: async (
      id: number
    ): Promise<customerContactDto[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TLKP_CUSTOMER_CONTACT +
            GET_ALL_CUSTOMER_CONTACT_BY_CUSTOMER_ID +
            `?customerId=${id}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const CustomerContactContext = Context;
export const useCustomerContactManager = useManager;
export const useCustomerContact = useConsumer;
